import { useEffect, useState } from 'react';
// Browse (Sam, Oct 14): the header count follows the client-side topic/keyword filter.
let current = null;
const subs = new Set();
export const setLiveResultCount = n => {
  current = typeof n === 'number' ? n : null;
  subs.forEach(f => f(current));
};
export const useLiveCount = fallback => {
  const [n, setN] = useState(current);
  useEffect(() => {
    subs.add(setN);
    // The panel may have set the count before this header subscribed.
    setN(current);
    return () => subs.delete(setN);
  }, []);
  return n == null ? fallback : n;
};
